<template>
  <section id="faq" class="faq">
    <div class="faq-content">
      <div class="main-content">
        <div class="faq-list-text-content">
          <!-- タイトル・サブタイトル -->
          <div class="text-content">
            <div class="title">{{ $t('page.faq.title') }}</div>
            <div class="sub-title">{{ $t('page.faq.sub-title') }}</div>
          </div>

          <!-- FAQ内容 -->
          <div
            id="faq-list-content"
            class="faq-list-content scroll-custom"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { getFaqList } from '~~/src/models/Faq'
const { locale } = useI18n()

onMounted(() => {
  createFaqList()
})

type pressedButtonDataType = {
  buttonId: number
  isOpenSlide: boolean
}

const pressedButton = ref<pressedButtonDataType>({
  buttonId: -1,
  isOpenSlide: false,
})

const clickFaqButton = (buttonId: number) => {
  const listItemId = 'list-item-' + buttonId
  const plusIconId = 'plus-icon-' + buttonId
  if (pressedButton.value.buttonId !== buttonId) {
    if (pressedButton.value.buttonId !== -1) {
      const oldListItemId = 'list-item-' + pressedButton.value.buttonId
      const oldPlusIconId = 'plus-icon-' + pressedButton.value.buttonId
      const oldButton = document.getElementById(oldListItemId)
      if (!oldButton) return
      oldButton.classList.remove('active')

      const oldPlusIcon = document.getElementById(oldPlusIconId)
      if (!oldPlusIcon) return
      oldPlusIcon.classList.remove('active')
    }

    const selectButton = document.getElementById(listItemId)
    if (!selectButton) return
    selectButton.classList.add('active')

    const plusIcon = document.getElementById(plusIconId)
    if (!plusIcon) return
    plusIcon.classList.add('active')

    const pressedButtonType: pressedButtonDataType = {
      buttonId,
      isOpenSlide: true,
    }
    pressedButton.value = pressedButtonType
  } else {
    const selectButton = document.getElementById(listItemId)
    if (!selectButton) return

    const plusIcon = document.getElementById(plusIconId)
    if (!plusIcon) return

    if (pressedButton.value.isOpenSlide) {
      selectButton.classList.remove('active')
      plusIcon.classList.remove('active')
    } else {
      selectButton.classList.add('active')
      plusIcon.classList.add('active')
    }
    pressedButton.value.isOpenSlide = !pressedButton.value.isOpenSlide
  }
}

const createFaqList = () => {
  const faqListContent = document.getElementById('faq-list-content')
  if (!faqListContent) return

  getFaqList(locale.value).forEach((value, index) => {
    const faqListItem = document.createElement('button')
    faqListItem.className = 'list-item'
    faqListItem.id = 'list-item-' + index
    faqListItem.onclick = () => {
      clickFaqButton(index)
    }

    const faqContent = document.createElement('div')
    faqContent.className = 'faq-content'

    const quationsIcon = document.createElement('div')
    quationsIcon.className = 'quations-icon'
    const quationsText = document.createElement('div')
    quationsText.innerText = 'Q'
    quationsText.className = 'text'
    quationsIcon.appendChild(quationsText)

    faqContent.appendChild(quationsIcon)

    const faqText = document.createElement('div')
    faqText.className = 'text'
    faqText.innerText = value.question
    faqContent.appendChild(faqText)

    const faqPlus = document.createElement('div')
    faqPlus.className = 'plus-icon'
    faqPlus.id = 'plus-icon-' + index

    const tate = document.createElement('tate')
    tate.className = 'tate'
    const yoko = document.createElement('yoko')
    yoko.className = 'yoko'

    faqPlus.appendChild(tate)
    faqPlus.appendChild(yoko)

    faqContent.appendChild(faqPlus)

    faqListItem.appendChild(faqContent)

    const slideContent = document.createElement('div')
    slideContent.className = 'slide-content'

    const answerIcon = document.createElement('div')
    answerIcon.className = 'answer-icon'
    const answerText = document.createElement('div')
    answerText.innerText = 'A'
    answerText.className = 'text'
    answerIcon.appendChild(answerText)

    slideContent.appendChild(answerIcon)

    const slideText = document.createElement('div')
    slideText.className = 'text'
    slideText.innerText = value.answer
    slideContent.appendChild(slideText)

    faqListItem.appendChild(slideContent)

    faqListContent.appendChild(faqListItem)
  })
}
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#faq {
  position: relative;
  text-align: center;
}

.faq-content {
  background: v.$common-white-color;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 168px 0;
  @include m.sp() {
    padding: 64px 0 96px;
  }

  .main-content {
    width: 100%;
    max-width: 1920px;
    display: flex;

    .faq-list-text-content {
      display: flex;
      flex-direction: column;
      width: 100%;

      .text-content {
        .title {
          color: v.$accent-color;
          font-size: 1.125rem;
          font-family: v.$accent-font-family;
          font-weight: v.$font-weight-light;
          margin: 0;
          @include m.sp() {
            font-size: 1rem;
            letter-spacing: 6.4px;
          }
        }

        .sub-title {
          color: v.$text-title-color;
          font-size: 1.375rem;
          line-height: 1.5;
          @include m.sp() {
            font-size: 1.25rem;
            letter-spacing: 3px;
          }
        }
      }

      :deep(.faq-list-content) {
        display: flex;
        flex-flow: column;
        width: 100%;
        max-width: calc(960px + 6%);
        overflow-y: auto;
        overflow-x: hidden;
        margin: 96px auto 0;
        padding: 0 3%;
        @include m.sp() {
          width: initial;
          max-width: initial;
          margin: 64px 16px;
        }

        .list-item {
          transition: 0.3s ease-out;
          cursor: pointer;
          height: fit-content;
          width: 100%;
          background: #00000000;
          border: 0;

          .faq-content {
            border-bottom: solid 1px v.$border-list-color;
            width: 100%;
            height: 70px;
            display: flex;
            position: relative;
            align-items: center;

            .quations-icon {
              position: absolute;
              width: 100%;
              display: flex;
              place-items: center;

              .text {
                color: black;
                position: absolute;
                text-align: center;
                font-size: 1.125rem;
                border: solid 1px v.$common-element-color;
                padding: 5px 12px 8px;
                font-family: v.$accent-font-family;
                font-weight: v.$font-weight-regular;
                @include m.sp() {
                  font-size: 0.875rem;
                  padding: 3px 10px;
                }
              }
            }

            .text {
              padding-left: 50px;
              text-align: start;
              font-size: 1rem;
              line-height: 24px;
              flex: 1;
              @include m.sp() {
                padding-left: 48px;
              }
            }

            .plus-icon {
              position: relative;
              width: 12px;
              height: 12px;

              .tate {
                transition: 0.3s ease-out;
                position: absolute;
                background: v.$common-element-color;
                border-radius: 0.1em;
                width: 1px;
                height: 12px;
              }
              .yoko {
                transition: 0.3s ease-out;
                position: absolute;
                top: 0;
                left: 50%;
                width: 1px;
                height: 12px;
                background: v.$common-element-color;
                border-radius: inherit;
                transform: rotate(90deg);
              }
              /* Firefox専用、線の潰れ対策 */
              @supports (-moz-appearance: none) {
                .tate {
                width: 1.01px;
                }
              }

              &.active {
                .tate {
                  transition: 0.3s ease-out;
                  transform: rotate(90deg);
                }
                .yoko {
                  transition: 0.3s ease-out;
                  transform: rotate(180deg);
                  opacity: 0;
                }
              }
            }
          }
          .slide-content {
            margin-top: 15px;
            transition: max-height 0.5s ease, opacity 0.5s ease;
            opacity: 0;
            width: 100%;
            max-height: 0;
            overflow: hidden;
            display: flex;

            .answer-icon {
              background: v.$bg-list-color;
              position: relative;
              width: 40px;
              height: 40px;
              display: flex;
              place-items: center;
              justify-content: center;
              @include m.sp() {
                width: 32px;
                height: 32px;
                padding: 0 16px;
              }

              .text {
                color: v.$accent-color;
                position: absolute;
                text-align: center;
                letter-spacing: 0;
                line-height: 0;
                font-size: 1.25rem;
                font-family: v.$accent-font-family;
                font-weight: v.$font-weight-regular;
                padding: 1px;
                @include m.sp() {
                  font-size: 1rem;
                }
              }
            }

            .text {
              max-width: 871px;
              text-align: start;
              font-size: 1rem;
              line-height: 24px;
              padding: 8px 12px 15px;
              @include m.sp() {
                padding: 4px 15px 20px;
              }
            }
          }
          &.active {
            .slide-content {
              max-height: 60vh;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
